<template>
  <div id="Tab5">
    <ValidationObserver ref="formPeiTab5" v-slot="{ dirty }">
      <SaveObserver name="saveObserverPeiTab5" :dirty="dirty">
        <div class="tab-content">
          <!-- Section A -->
          <SectionTitle
            icon="fas fas fa-address-card"
            content="VI. Otras Consideraciones y Servicios"
            container-class="tag-badge-main-info mt-5 mb-4"
          />

          <Error
            v-if="controversyVI && controversyVI.existControversy"
            is-alert-mode
            :message="
              '<b>Parte en Controversia: </b>' +
                controversyVI.informationMessage
            "
          />

          <SectionTitle
            :has-line="true"
            content="A. Grado en el que recibirá acceso curricular"
            container-class="mb-4"
          />
          <div class="row-group  ml-3 mb-4">
            <div class="row">
              <div class="col-lg-3">
                <CustomInput
                  v-model="model.grade"
                  class="readonly"
                  :disabled="true"
                />
              </div>
            </div>
          </div>

          <Error
            v-if="hasDifferentGrade"
            is-alert-mode
            message="El grado seleccionado no es el mismo o el próximo según los datos en el sistema."
            class="mt-1"
          />

          <!-- Section B -->
          <SectionTitle
            :has-line="true"
            content="B. Áreas académicas en las que participará en el salón regular"
            container-class="mb-4"
          />
          <Error
            v-if="
              alertAlternativeUbications &&
                AcademicArea &&
                AcademicArea.selected &&
                AcademicArea.selected.length > 0
            "
            is-alert-mode
            :message="resources['0659']"
            variant="withoutspacing"
          />
          <div ref="academy" class="panel-simple">
            <div class="header global-thead-dark">
              <div class="col-md-12">
                <span>Lista de Áreas Académicas seleccionadas</span>
              </div>
            </div>
            <div class="bg-rectangle-gradiant" />
            <div>
              <div
                v-if="
                  AcademicArea.isModified == false &&
                    AcademicArea.selected.length == 0 &&
                    peiIsDraft &&
                    canEditTab5
                "
                class="panel-row-without-selector"
              >
                <div class="col-12 text-center">
                  <button
                    id="btnFA"
                    class="btn bg-light-white w-75 pt-1"
                    @click="ModifyAcademicArea()"
                  >
                    <i class="fas fa-file-plus pr-4 text-green" />
                    <span class="text-button-add-document">
                      Presione aquí para añadir áreas académicas
                    </span>
                  </button>
                </div>
              </div>

              <div v-if="AcademicArea.isModified == true">
                <div class="col-12 mb-2">
                  <div class="row">
                    <div class="col-4 pt-0">
                      <div class="tag-badge">
                        <span class="dot text-center pl-1">
                          <i
                            class="fas fa-plus orange-icon orange-icon-badge-align"
                          />
                        </span>
                        <span class="tag-badge-title py-1 pl-2">
                          Añadir Áreas Académicas
                        </span>
                      </div>
                    </div>
                    <div class="col-4 pt-0" />
                    <div class="col-4 pt-0 d-flex justify-content-end">
                      <span
                        class="close-border p-1 mr-2 mt-0"
                        @click="AcademicArea.isModified = false"
                      >
                        <i class="fas fa-window-close close-ico" />
                        Cerrar
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <multiSelect
                    :all-items="AcademicArea.items"
                    :item-type-name="'Objeto'"
                    :selected-items="AcademicArea.temporary"
                    :column-count="1"
                    @itemSelected="onItemSelectedAcademyArea"
                  />
                </div>
                <Error
                  class="ml-3 mt-3"
                  is-alert-mode
                  message="Puede seleccionar una(1) o más áreas académicas. Selección múltiple."
                />
                <div class="col-12">
                  <h6 class="text-muted">
                    Áreas Académicas seleccionadas
                  </h6>
                  <div class="panel">
                    <BadgeTitle
                      v-for="(item, index) in AcademicArea.temporary"
                      :key="index"
                      :title="item.name"
                      :highlight="item.highlight"
                      :has-icon="!peiIsDraft || !canEditTab5"
                      @delete="DeleteAcademicArea(item)"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="
                AcademicArea.selected.length > 0 && !AcademicArea.isModified
              "
              class="panel-row-without-selector"
            >
              <BadgeTitle
                v-for="(item, index) in AcademicArea.selected"
                :key="index"
                :title="item.name"
                :highlight="item.highlight"
                :has-icon="!peiIsDraft || (!canEditTab5 || (canUseTabEditRestriction && !hasSubSectionBinAmendant)) && !admendmentIsEmpty"
                @delete="DeleteAcademicArea(item)"
              />
            </div>

            <div class="text-right">
              <button
                v-if="AcademicArea.isModified"
                class="btn p-1 btn-action btn-green btn-success-softer"
                @click="SaveAcademicArea()"
              >
                <span class="font-weight-light">Guardar</span>
              </button>

              <div class="my-2 py-2 w-100" />

              <button
                v-if="
                AcademicArea.selected.length > 0 &&
                    !AcademicArea.isModified &&
                    peiIsDraft &&                    
                    canEditTab5 &&  (admendmentIsEmpty ||  !canUseTabEditRestriction || hasSubSectionBinAmendant )
                "
                class="btn p-1 btn-action btn-green btn-success-softer"
                @click="ModifyAcademicArea()"
              >
                <span class="font-weight-light">
                  <i class="fas fa-edit" />
                  Modificar
                </span>
              </button>
            </div>

            <Error
              v-if="validateAcademicArea()"
              variant="no-border pb-4"
              :message="resources['6001']"
            />
          </div>

          <!-- Section C -->
          <SectionTitle
            :has-line="true"
            content="C. Explique hasta qué punto el estudiante no participará en el currículo general en el salón regular y las razones"
            container-class="mb-4"
          />
          <div class="row-group ml-3">
            <div class="row">
              <div class="col-lg-4">
                <span>¿El estudiante participará en el currículo general?</span>
              </div>
              <div class="col-lg-4">
                <div class="input-group mb-3">
                  <input
                    id="estudianteParticipara1"
                    v-model="model.serviceIdPartCurricularDescription"
                    type="radio"
                    class="hidden"
                    :disabled="!peiIsDraft || (( !canEditTab5 || (canUseTabEditRestriction && !hasSubSectionCinAmendant) ) && !admendmentIsEmpty)"
                    value="1"
                  />
                  <label class="entry" for="estudianteParticipara1">
                    <div class="circle" />
                    <div class="entry-label">Sí</div>
                  </label>
                  <input
                    id="estudianteParticipara2"
                    v-model="model.serviceIdPartCurricularDescription"
                    type="radio"
                    class="hidden"
                    :disabled="!peiIsDraft || (( !canEditTab5 || (canUseTabEditRestriction && !hasSubSectionCinAmendant)) && !admendmentIsEmpty)"
                    value="0"
                  />
                  <label class="entry" for="estudianteParticipara2">
                    <div class="circle" />
                    <div class="entry-label">No</div>
                  </label>
                  <div
                    v-if="model.serviceIdPartCurricularDescription != null"
                    class="highlight"
                  />

                  <Error
                    v-if="validatePartCurricular()"
                    variant="no-border pl-0"
                    :message="resources['6002']"
                  />
                </div>
              </div>
            </div>
            <div class="row mr-3">
              <div class="form-group pb-2 ml-3 w-100">
                <ValidationProvider
                  v-slot="{ invalid }"
                  :rules="`${validationTriggered.validation ? 'required' : ''}`"
                  immediate
                  name=""
                >
                  <CustomTextArea
                    v-show="model.serviceIdPartCurricularDescription === '0'"
                    v-model="
                      model.serviceReasonCurricularNoParticipationDescription
                    "
                    :placeholder="'Escribir razones adicionales...'"
                    :maxlength="500"
                    :rows="5"
                    :disabled="!peiIsDraft || (( !canEditTab5 || (canUseTabEditRestriction && !hasSubSectionCinAmendant) && !admendmentIsEmpty))"
                    :error="`${invalid ? 'error' : ''}`"
                    :custom-error-msg="resources['6003']"
                  />
                </ValidationProvider>
              </div>
            </div>
          </div>

          <!-- Section D -->
          <SectionTitle
            :has-line="true"
            content="D. Áreas y actividades extracurriculares en las cuales el estudiante participará con estudiantes regulares"
            container-class="mt-4 mb-4"
          />

          <div ref="academy" class="panel-simple">
            <div class="header global-thead-dark">
              <div class="col-md-12">
                <span>
                  Lista de Áreas y Actividades Extracurriculares seleccionadas
                </span>
              </div>
            </div>
            <div class="bg-rectangle-gradiant" />
            <div>
              <div
                v-if="
                  (AreaExtracurricular.isModified == false &&
                    AreaExtracurricular.selected.length == 0 &&
                    peiIsDraft &&
                    canEditTab5)           
                    &&
                    (admendmentIsEmpty || !canUseTabEditRestriction || hasSubSectionDEinAmendant)
                "
                class="panel-row-without-selector"
              >
                <div class="col-12 text-center">
                  <button
                    id="btnFA"
                    class="btn bg-light-white w-75 pt-1"
                    @click="ModifyAreaExtracurricular()"
                  >
                    <i class="fas fa-file-plus pr-4 text-green" />
                    <span class="text-button-add-document">
                      Presione aquí para añadir áreas y actividades
                      extracurriculares
                    </span>
                  </button>
                </div>
              </div>

              <div v-if="AreaExtracurricular.isModified == true">
                <div class="col-12 mb-2">
                  <div class="row">
                    <div class="col-6 pt-0">
                      <div class="tag-badge">
                        <span class="dot text-center pl-1">
                          <i
                            class="fas fa-plus orange-icon orange-icon-badge-align"
                          />
                        </span>
                        <span class="tag-badge-title py-1 pl-2">
                          Añadir áreas y actividades extracurriculares
                        </span>
                      </div>
                    </div>
                    <div class="col-6 pt-0 d-flex justify-content-end">
                      <span
                        class="close-border p-1 mr-2 mt-0"
                        @click="AreaExtracurricular.isModified = false"
                      >
                        <i class="fas fa-window-close close-ico" />
                        Cerrar
                      </span>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <multiSelect
                    :all-items="AreaExtracurricular.items"
                    :item-type-name="'Objeto'"
                    :selected-items="AreaExtracurricular.temporary"
                    :column-count="1"
                    @itemSelected="onItemSelectedAcademyAreaAndActivity"
                  />
                </div>
                <Error
                  class="ml-3 mt-3"
                  is-alert-mode
                  message="Puede seleccionar una(1) o más áreas y actividades extracurriculares. Selección múltiple."
                />
                <div class="col-12">
                  <h6 class="text-muted">
                    Áreas y Actividades extracurriculares seleccionadas
                  </h6>
                  <div class="panel">
                    <BadgeTitle
                      v-for="(item, index) in AreaExtracurricular.temporary"
                      :key="index"
                      :title="item.name"
                      :highlight="item.highlight"
                      :has-icon="(!peiIsDraft || !canEditTab5)"
                      @delete="DeleteAreaExtracurricular(item)"
                    />
                  </div>
                  <Error
                    class="mt-3"
                    v-if="hasAreaError"
                    message="Al seleccionar En estos momentos no se considera no es posible añadir una actividad."
                  />
                </div>
              </div>
            </div>

            <div
              v-if="
                AreaExtracurricular.selected.length > 0 &&
                  !AreaExtracurricular.isModified
              "
              class="row ml-0 mr-0 panel-row-without-selector"
            >
              <BadgeTitle
                v-for="(item, index) in AreaExtracurricular.selected"
                :key="index"
                :title="item.name"
                :highlight="item.highlight"
                :has-icon="((!peiIsDraft || !canEditTab5 || !hasSubSectionDEinAmendant ) && canUseTabEditRestriction && !admendmentIsEmpty) || !peiIsDraft"
                @delete="DeleteAreaExtracurricular(item)"
              />
            </div>

            <div class="text-right">
              <button
                v-if="AreaExtracurricular.isModified"
                class="btn p-1 btn-action btn-green btn-success-softer"
                @click="SaveAreaExtracurricular()"
              >
                <span class="font-weight-light">Guardar</span>
              </button>

              <div class="my-2 py-2 w-100" />

              <button
                v-if="
                  AreaExtracurricular.selected.length > 0 &&
                    !AreaExtracurricular.isModified &&
                    peiIsDraft &&
                    canEditTab5  &&  (admendmentIsEmpty ||  !canUseTabEditRestriction || hasSubSectionDEinAmendant )
                "
                class="btn p-1 btn-action btn-green btn-success-softer"
                @click="ModifyAreaExtracurricular()"
              >
                <span class="font-weight-light">
                  <i class="fas fa-edit" />
                  Modificar
                </span>
              </button>
            </div>
          </div>

          <!-- Section E -->
          <SectionTitle
            :has-line="true"
            content="E. Explique las razones por las cuales el estudiante no participará de las actividades que no fueron marcadas"
            container-class="mb-4"
          />
          <div ref="academy" class="panel-simple">
            <div class="header global-thead-dark">
              <div class="col-md-12">
                <span>Actividades NO seleccionadas</span>
              </div>
            </div>
            <div class="bg-rectangle-gradiant" />
            <div class="pb-3">
              <div class="row ml-0 mr-0  panel-row-without-selector">
                <BadgeTitle
                  v-for="(item, index) in notSelectedAreasExtraCurricular"
                  :key="index"
                  :title="item.name"
                  :highlight="item.highlight"
                  :has-icon="true"
                  @delete="DeleteNotSelectedAreas"
                />
              </div>
            </div>
          </div>

          <div class="row mr-1">
            <div class="form-group pb-2 ml-3 w-100">
              <ValidationProvider
                v-slot="{ invalid }"
                :rules="`${
                  validationTriggered.validation && !allAreasSelected?
                  'required' : ''
                }`"
                immediate
                name=""
              >
                <CustomTextArea
                  ref="noparticipationbox"
                  v-model="
                    model.serviceAreaExtraReasonNoParticipationDescription
                  "
                  :placeholder="'Explique las razones...'"
                  :maxlength="500"
                  :rows="5"
                  :disabled="
                   !peiIsDraft || (enableActivitiesAreasReasonsDescriptionBox || !canEditTab5 || (canUseTabEditRestriction && !hasSubSectionDEinAmendant)) 
                   && !admendmentIsEmpty
                  "
                  :error="
                    `${
                      invalid && !allAreasSelected
                        ? 'error'
                        : ''
                    }`
                  "
                  :custom-error-msg="resources['6016']"
                />
              </ValidationProvider>
            </div>
          </div>
        </div>
      </SaveObserver>
    </ValidationObserver>
  </div>
</template>

<script>
import { SectionTitle } from '@/components/pei/shared';
import { ValidationObserver } from 'vee-validate';
import { BadgeTitle } from '@/components/pei/shared';
import mixAlert from '@/mixin/alert.mixin';
import mixWait from '@/mixin/loading.mixin';
import multiSelect from '@/components/common/MultiSelectionPicker';
import CustomInput from '@/components/common/CustomInput';
import CustomTextArea from '@/components/common/CustomTextArea';
import SaveObserver from '@/components/common/SaveObserver';
import Error from '@/components/common/Error';
import store from '@/store/index';
import alternatePlacements from '@/utils/constants/alternatePlacements';
import peiSections from '@/utils/constants/pei/peiSections.js';
import peiStatus from '@/utils/constants/pei/peiStatus';

// Services.
import resourcesService from '@/services/resources.js';

// Sub-sections from PeiPartEvaluationAmendment, representing areas selected for editing in an amendment
const SUB_SECTION_A = 33;
const SUB_SECTION_B = 34;
const SUB_SECTION_C = 35;
const SUB_SECTION_D_E = 36;

//Special option
const EnEstosMomentosNoSeConsidera = 57;

export default {
  name: 'Tab5PEI',
  mixins: [mixAlert, mixWait],
  components: {
    SectionTitle,
    ValidationObserver,
    CustomInput,
    CustomTextArea,
    multiSelect,
    BadgeTitle,
    SaveObserver,
    Error,
  },
  data() {
    return {
      Info: {},
      model: {
        ServiceAreaExtraReasonNoParticipationDescription: null,
      },
      peiId: store.getters.SelectedPei,
      showTxtRazones: true,
      AcademicArea: {
        name: 'ServiceAcademicArea',
        isModified: false,
        items: [],
        selected: [],
        temporary: [],
      },
      AreaExtracurricular: {
        name: 'PeiServiceAreaExtracurricular',
        isModified: false,
        items: [],
        selected: [],
        temporary: [],
      },
      resources: [],
      oldServiceAreaExtraReasonNoParticipationDescription: '',
      canEditTab5: store.getters.HasPermission('pei.editTab5'),
    };
  },
  computed: {
    allAreasSelected() {
      const selectedAreaIds = this.AreaExtracurricular.selected.map(x => x.id);
      let availableAreas = this.AreaExtracurricular.items.filter(x => !selectedAreaIds.includes(x.id));

      return availableAreas.filter(x => x.id != EnEstosMomentosNoSeConsidera).length == 0;
    },
    hasAreaError() {
      if (this.AreaExtracurricular.temporary.length > 1)
        return this.AreaExtracurricular.temporary.some(x => x.id == EnEstosMomentosNoSeConsidera);

      return false;
    },
    peiIsDraft() {
      return store.getters.SelectedPeiStatus == peiStatus.Borrador;
    },   
    validationTriggered() {
      return store.getters.getPeiValidationTriggered;
    },
    alertAlternativeUbications() {
      return store.getters.getPeiHasAlternativeAcademicUbications === false;
    },
    notSelectedAreasExtraCurricular() {
      const selectedAreaIds = this.AreaExtracurricular.selected.map(x => x.id);
      const availableAreas = this.AreaExtracurricular.items.filter(x => !selectedAreaIds.includes(x.id));

      return selectedAreaIds.length > 0 ?
        availableAreas.filter(x => x.id != EnEstosMomentosNoSeConsidera) :
        availableAreas;
    },
    hasDifferentGrade()
    { 
      let currentGradeId = this.$store.getters.SelectedStudent?.gradeId;        
      
      return (       
        currentGradeId + 1 !== this.model.gradeId &&
        currentGradeId !== this.model.gradeId        
      );
    },
    enableActivitiesAreasReasonsDescriptionBox() {
      const self = this;
      const valid = self.notSelectedAreasExtraCurricular.length == 0;

      return valid;
    },
    controversyVI() {
      return store.getters.getPeiControversies(peiSections.VI);
    },
    admendmentIsEmpty(){
      return this.$store.state["$_admendment"].sections.length == 0;
    },
    canUseTabEditRestriction(){
      return this.$store.state["$_admendment"].correlationParameter[0].staticValue === "true";
    },
    hasSubSectionAinAmendant(){
      return this.$store.state["$_admendment"].sections.some(x=>x.subSectionId == SUB_SECTION_A);
    },
    hasSubSectionBinAmendant(){
      return this.$store.state["$_admendment"].sections.some(x=>x.subSectionId == SUB_SECTION_B);
    },
    hasSubSectionCinAmendant(){
      return this.$store.state["$_admendment"].sections.some(x=>x.subSectionId == SUB_SECTION_C);
    },
    hasSubSectionDEinAmendant(){
      return this.$store.state["$_admendment"].sections.some(x=>x.subSectionId == SUB_SECTION_D_E);
    },
  },
  activated() {
    store.commit('setSaveMethod', this.save);
    store.commit('setSaveBtnVisibility', true);
  },
  async mounted() {
    await this.loadResources();
    this.Info = this.$attrs.Info;
    this.getOtherConsiderationPei();
    await this.LoadAcademicArea();
    await this.LoadSelectedAcademicArea();
    await this.getAlternativeUbications();
    this.LoadAreaExtracurricular();
    this.LoadSelectedAreaExtracurricular();
  },
  methods: {
    saveTab() {
      store.dispatch('saveChangesOnForm');
    },
    async save() {
      try {
        if (this.hasAreaError)
          return;

        await this.setAreaExtraReasonNoParticipationDescription();
        await this.setReasonCurricularNoParticipationDescription();

        this.ShowToast(
          this.resources['R03200110'],
          this.resources['R03200109'],
          'success'
        );
      } catch (err) {
        this.ShowToast(
          err.message,
          'Error al intentar guardar los datos',
          'error'
        );
      }
    },
    async getAlternativeUbications() {
      let self = this;
      self
        .$ApiGet('api/pei/getalternativeubications/' + self.peiId)
        .then((res) => {
          let alternativeUbications = res.data;
          let hasAlternativeAcademicUbications = alternativeUbications.find(
            (x) =>
              x.recommendFlag == '1' &&
              (x.alternatePlacementCodeId ==
                alternatePlacements.SalonRegularConServiciosYAyudaSuplementaria ||
                x.alternatePlacementCodeId ==
                  alternatePlacements.SalonRegularConServiciosDeSalonRecurso)
          );
          store.commit(
            'setPeiHasAlternativeAcademicUbications',
            hasAlternativeAcademicUbications != null
          );
        })
        .catch((err) => {
          self.ShowToast(err, self.resources['R03200108'], 'error');
        });
    },
    async loadResources() {
      let resourceCodes = [
        '6001',
        '6002',
        '6003',
        '6016',
        '0659',
        'R03200108',
        'R03200109',
        'R03200110',
      ];

      this.resources = await resourcesService.LoadValidationMessages(
        resourceCodes
      );
    },
    ModifyAcademicArea() {
      this.AcademicArea.isModified = true;

      this.AcademicArea.temporary = this.AcademicArea.selected.map((obj) => ({
        ...obj,
      }));
    },
    SaveAcademicArea() {
      let self = this;
      let ids = [];

      ids = self.AcademicArea.temporary
        .filter((i) => !self.AcademicArea.selected.find((e) => e.id === i.id))
        .map((i) => i.id);

      self
        .$ApiPost('api/pei/AddPeiServiceAcademicArea', {
          PeiId: store.getters.SelectedPei,
          PeiCodes: ids,
        })
        .then(() => {
          self.ShowToast(
            self.resources['R03200110'],
            self.resources['R03200109'],
            'success'
          );
          self.AcademicArea.isModified = false;

          self.AcademicArea.selected = self.AcademicArea.temporary.map(
            (obj) => ({
              ...obj,
            })
          );
          store.commit(
            'setPeiHasAcademicAreas',
            self.AcademicArea.selected.length > 0
          );
        })
        .catch((errm) => {
          self.ShowToast(errm.message, '', 'error');
        })
        .finally(() => {
          self.AcademicArea.temporary = [];
          if (!this.enableActivitiesAreasReasonsDescriptionBox) {
            this.model.serviceAreaExtraReasonNoParticipationDescription = this.oldServiceAreaExtraReasonNoParticipationDescription;
          } else {
            this.model.serviceAreaExtraReasonNoParticipationDescription = null;
          }
        });
    },
    async LoadAcademicArea() {
      let self = this;
      self
        .$ApiGet('api/pei/GetAllPeiServiceAcademicArea')
        .then((response) => {
          self.AcademicArea.items = response.data;
        })
        .catch((errm) => {
          self.ShowToast(errm.message, '', 'error');
        });
    },
    async LoadSelectedAcademicArea() {
      let self = this;
      self
        .$ApiGet('api/pei/GetSelectedPeiServiceAcademicArea', {
          peiId: store.getters.SelectedPei,
        })
        .then((response) => {
          self.AcademicArea.selected = response.data;
          store.commit(
            'setPeiHasAcademicAreas',
            self.AcademicArea.selected.length > 0
          );
        })
        .catch((errm) => {
          self.ShowToast(errm.message, '', 'error');
        });
    },
    RemoveAcademicArea(item) {
      let self = this;

      self.AcademicArea.temporary.splice(
        this.AcademicArea.temporary.indexOf(item),
        1
      );
    },
    DeleteNotSelectedAreas() {},
    DeleteAcademicArea(item) {
      let self = this;

      let params = {};

      params.peiId = store.getters.SelectedPei;
      params.peiCode = item.id;

      self
        .$ApiDelete('api/pei/DeletePeiServiceAcademicArea', params)
        .then(() => {
          self.AcademicArea.selected.splice(
            self.AcademicArea.selected.indexOf(item),
            1
          );
          store.commit(
            'setPeiHasAcademicAreas',
            self.AcademicArea.selected.length > 0
          );
          if (self.AcademicArea.temporary.length > 0) {
            self.AcademicArea.temporary.splice(
              this.AcademicArea.temporary.indexOf(item),
              1
            );
          }
          if (!this.enableActivitiesAreasReasonsDescriptionBox) {
            this.model.serviceAreaExtraReasonNoParticipationDescription = this.oldServiceAreaExtraReasonNoParticipationDescription;
          } else {
            this.model.serviceAreaExtraReasonNoParticipationDescription = null;
          }
        })
        .catch((errm) => {
          self.ShowToast(errm.message, '', 'error');
        });
    },
    ModifyAreaExtracurricular() {
      this.AreaExtracurricular.isModified = true;

      this.AreaExtracurricular.temporary = this.AreaExtracurricular.selected.map(
        (obj) => ({ ...obj })
      );
    },
    SaveAreaExtracurricular() {
      if (this.hasAreaError)
        return;

      let self = this;
      let ids = [];

      ids = self.AreaExtracurricular.temporary
        .filter(
          (i) => !self.AreaExtracurricular.selected.find((e) => e.id === i.id)
        )
        .map((i) => i.id);

      self
        .$ApiPost('api/pei/AddPeiServiceAreaExtracurricular', {
          PeiId: store.getters.SelectedPei,
          PeiCodes: ids,
        })
        .then(() => {
          self.AreaExtracurricular.isModified = false;

          this.AreaExtracurricular.selected = this.AreaExtracurricular.temporary.map(
            (obj) => ({ ...obj })
          );
        })
        .catch((errm) => {
          self.ShowToast(errm.message, '', 'error');
        })
        .finally(() => {
          self.AreaExtracurricular.temporary = [];
          if (!this.enableActivitiesAreasReasonsDescriptionBox) {
            this.model.serviceAreaExtraReasonNoParticipationDescription = this.oldServiceAreaExtraReasonNoParticipationDescription;
          } else {
            this.model.serviceAreaExtraReasonNoParticipationDescription = null;
          }
        });
    },
    LoadAreaExtracurricular() {
      let self = this;
      self
        .$ApiGet('api/pei/GetAllPeiServiceAreaExtracurricular')
        .then((response) => {
          self.AreaExtracurricular.items = response.data;
        })
        .catch((errm) => {
          self.ShowToast(errm.message, '', 'error');
        });
    },
    LoadSelectedAreaExtracurricular() {
      let self = this;
      self
        .$ApiGet('api/pei/GetSelectedPeiServiceAreaExtracurricular', {
          peiId: store.getters.SelectedPei,
        })
        .then((response) => {
          self.AreaExtracurricular.selected = response.data;
        })
        .catch((errm) => {
          self.ShowToast(errm.message, '', 'error');
        });
    },
    RemoveAreaExtracurricular(item) {
      let self = this;

      self.AreaExtracurricular.temporary.splice(
        this.AreaExtracurricular.temporary.indexOf(item),
        1
      );
    },
    DeleteAreaExtracurricular(item) {
      let self = this;

      let params = {};

      params.peiId = store.getters.SelectedPei;
      params.peiCode = item.id;

      self
        .$ApiDelete('api/pei/DeletePeiServiceAreaExtracurricular', params)
        .then(() => {
          self.AreaExtracurricular.selected.splice(
            self.AreaExtracurricular.selected.indexOf(item),
            1
          );

          if (self.AreaExtracurricular.temporary.length > 0) {
            self.AreaExtracurricular.temporary.splice(
              this.AreaExtracurricular.temporary.indexOf(item),
              1
            );
          }

          if (!this.enableActivitiesAreasReasonsDescriptionBox) {
            this.model.serviceAreaExtraReasonNoParticipationDescription = this.oldServiceAreaExtraReasonNoParticipationDescription;
          } else {
            this.model.serviceAreaExtraReasonNoParticipationDescription = null;
          }
        })
        .catch((errm) => {
          self.ShowToast(errm.message, '', 'error');
        });
    },
    getOtherConsiderationPei() {
      this.$ApiGet(`/api/pei/${this.peiId}/OtherConsiderations`)
        .then((res) => {
          this.model = res.data;
          if (
            this.model.serviceReasonCurricularNoParticipationDescription !==
            null
          ) {
            this.showTxtRazones = true;
          } else {
            this.showTxtRazones = false;
          }

          this.oldServiceAreaExtraReasonNoParticipationDescription =
            res.data.serviceAreaExtraReasonNoParticipationDescription;
        })
        .catch((err) => {
          this.response = err;
        });
    },
    async setAreaExtraReasonNoParticipationDescription() {
      await this.$ApiPost(
        `/api/pei/${this.peiId}/setareaextrareasonnoparticipation`,
        this.model
      );
    },
    async setReasonCurricularNoParticipationDescription() {
      await this.$ApiPost(
        `/api/pei/${this.peiId}/ReasonCurricularNoParticipation`,
        this.model
      );
    },
    onItemSelectedAcademyArea(item) {
      //add highlight effect
      this.AcademicArea.temporary.map((s) => {
        if (s.id === item.id) {
          s.highlight = true;
        }
      });
    },
    onItemSelectedAcademyAreaAndActivity(item) {
      //add highlight effect
      this.AreaExtracurricular.temporary.map((s) => {
        if (s.id === item.id) {
          s.highlight = true;
        }
      });
    },
    // Validations.
    // Validation for academic area.
    validateAcademicArea() {
      return (
        this.validationTriggered.validation &&
        this.AcademicArea.selected.length <= 0
      );
    },
    // Validation for curriculum participation question.
    validatePartCurricular() {
      return (
        this.validationTriggered.validation &&
        this.model.serviceIdPartCurricularDescription === null
      );
    },
  },
};
</script>

<style scoped src="@/assets/css/component/panel-simple.css"></style>

<style scoped>
.close-border {
  border: 1px solid #2db782;
  border-radius: 50px;
  display: inline-block;
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 1.125rem;
  line-height: 1.6em;
  text-align: center;
  width: 7.1875rem;
  height: 2.6875‬rem;
  cursor: pointer;
  color: #2db782;
}

.close-ico {
  color: #2db782;
  margin-right: 3px;
}

.fa-times-circle {
  font-size: 18px;
  vertical-align: top;
}

.fa-orange {
  color: #ff7058;
}

.badge-orange {
  background-color: #ff7058;
  border: 1px solid #ff7058;
}

.badge-disable {
  background-color: transparent;
  border: 1px solid #b5c3bc;
  text-align: left;
  font: Regular 16px/19px Lato;
  letter-spacing: 0;
  color: #11291b;
  opacity: 1;
}

.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}

.title-section {
  text-align: left;
  font: Bold 16px/19px Lato;
  letter-spacing: 0;
  color: #11291b;
}

.info-titule {
  margin-left: 17px;
  margin-top: -35px;
  margin-bottom: 20px;
  text-align: left;
  font: Bold 14px/17px Lato;
  letter-spacing: 0;
  color: #727272;
  opacity: 1;
}

.custompadding {
  padding: 1.2rem 0rem 1.2rem 2rem !important;
}
.list-group-item.text-center {
  background: #fafbfa !important;
  padding: 1rem !important;
}
.readonly {
  width: 210px !important;
  height: 40px !important;
}

.tag-badge {
  display: inline-block;
  padding-right: 1em;
  padding-bottom: 0.5%;
  background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 26px;
  cursor: pointer;
}

.dot {
  width: 33px;
  height: 33px;
  border-radius: 50%;
  display: inline-block;
  opacity: 1;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 10px #00000029;
  padding-top: 7px;
}

.orange-icon {
  color: #ff7058;
  font-size: 15pt;
  padding-right: 4px;
  line-height: 23px;
}

.orange-icon-badge-align {
  vertical-align: top;
}

.tag-badge-title {
  text-align: left;
  font: Bold 18px/22px Lato;
  letter-spacing: 0;
  color: #11291b;
}

.alert-warning {
  background: #fff5e8 0% 0% no-repeat padding-box;
  border: 1px solid #fdac41;
  border-radius: 4px;
  opacity: 1;
}

.alert-icon {
  float: left;
  padding-top: 0.75%;
}

.alert-content {
  margin-left: 1.5%;
}

.alert span {
  text-align: left;
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  color: #af6708;
  display: inline-grid;
}

.panel-simple {
  margin-top: 0px;
}
</style>
